import { render, staticRenderFns } from "./AgregadoModal.vue?vue&type=template&id=2c2c9154&scoped=true"
import script from "./AgregadoModal.vue?vue&type=script&lang=js"
export * from "./AgregadoModal.vue?vue&type=script&lang=js"
import style0 from "./AgregadoModal.vue?vue&type=style&index=0&id=2c2c9154&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2c9154",
  null
  
)

export default component.exports